import styled from "styled-components";
import { Link } from "react-router-dom";

export const MenuHeader = styled.div``;

export const MenuHeaderLink = styled(Link)`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 126.2%;
  color: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
  margin: 0 15px;
  transition: 0.2s;
  &:hover {
    color: #0088cc;
  }
  @media (max-width: 1199.98px) {
    font-size: 16px;
    margin: 0 10px;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
`;
